import { Component, input } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { getFieldValue } from '@core/jss-utils';

@Component({
  selector: 'wl-error',
  templateUrl: './error.component.html',
  standalone: true,
})
export class ErrorComponent {
  readonly rendering = input<InnogyComponentRendering>();

  onClick() {
    const msg = getFieldValue<string>(
      this.rendering(),
      'errorMessage',
      'Debug error message'
    );
    throw new Error(msg);
  }
}
